"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersectionObserver = exports.useEnablingChat = exports.useChatListCollapse = exports.useUpdateMessage = exports.useAddMessage = exports.useMessages = exports.useContacts = exports.useUpdateChat = exports.useDirectChat = exports.useChat = void 0;
var react_1 = require("react");
var data_1 = require("./data");
var helpers_1 = require("./helpers");
var useContacts = function () {
    var _a = (0, react_1.useState)(undefined), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)("pending"), status = _b[0], setStatus = _b[1];
    (0, react_1.useEffect)(function () {
        (0, data_1.fetchContacts)()
            .then(function (response) {
            setData(response);
            setStatus("success");
        })
            .catch(function () { return setStatus("error"); });
    }, []);
    return { data: data, status: status };
};
exports.useContacts = useContacts;
var useMessages = function (chatId, initialPage) {
    if (initialPage === void 0) { initialPage = 0; }
    var _a = (0, react_1.useState)(undefined), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)("pending"), status = _b[0], setStatus = _b[1];
    var _c = (0, react_1.useState)(initialPage), page = _c[0], setPage = _c[1];
    var _d = (0, react_1.useState)(false), isFetchingNextPage = _d[0], setIsFetchingNextPage = _d[1];
    var _e = (0, react_1.useState)(true), hasNextPage = _e[0], setHasNextPage = _e[1];
    var abortControllerRef = (0, react_1.useRef)(null); // Utilize AbortController to prevent race conditions
    var handleResponse = function (response) {
        if (response.length === 0)
            setHasNextPage(false);
        setData(function (prevData) {
            return prevData === undefined
                ? response
                : (0, helpers_1.sortFromLatestToOldest)(__spreadArray(__spreadArray([], prevData, true), response, true).filter(function (item, index, self) {
                    return index === self.findIndex(function (t) { return t.id === item.id; });
                })
                    .filter(function (item) { return typeof item.id === "number"; }));
        });
    };
    var fetchNextPage = function () {
        var nextPage = page + 1;
        setIsFetchingNextPage(true);
        (0, data_1.fetchMessages)(chatId, nextPage)
            .then(function (response) {
            handleResponse(response);
            setPage(nextPage);
        })
            .finally(function () {
            setIsFetchingNextPage(false);
        });
    };
    var refetchFirstPage = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, data_1.fetchMessages)(chatId, initialPage).then(function (response) {
                    handleResponse(response);
                    return response;
                })];
        });
    }); };
    (0, react_1.useEffect)(function () {
        var fetchData = function (pageNumber) { return __awaiter(void 0, void 0, void 0, function () {
            var abortController;
            var _a;
            return __generator(this, function (_b) {
                (_a = abortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
                abortController = new AbortController();
                abortControllerRef.current = abortController;
                return [2 /*return*/, (0, data_1.fetchMessages)(chatId, pageNumber, abortController.signal)
                        .then(function (response) {
                        handleResponse(response);
                        setStatus("success");
                    })
                        .catch(function (error) {
                        if (error.name !== "AbortError") {
                            setStatus("error");
                        }
                    })];
            });
        }); };
        fetchData(initialPage);
        return function () {
            var _a;
            (_a = abortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        };
    }, []);
    return {
        data: data,
        setData: setData,
        status: status,
        isFetchingNextPage: isFetchingNextPage,
        hasNextPage: hasNextPage,
        fetchNextPage: fetchNextPage,
        refetchFirstPage: refetchFirstPage,
        abortControllerRef: abortControllerRef,
    };
};
exports.useMessages = useMessages;
var useAddMessage = function () {
    var mutate = function (message) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, (0, data_1.postMessage)(message)];
    }); }); };
    return { mutate: mutate };
};
exports.useAddMessage = useAddMessage;
var useUpdateMessage = function () {
    var mutate = function (messageToUpdate, fieldsToUpdate) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, (0, data_1.patchMessage)(messageToUpdate, fieldsToUpdate)];
    }); }); };
    return { mutate: mutate };
};
exports.useUpdateMessage = useUpdateMessage;
/**
 * @param chatId Chat id
 * @param refetchInterval Frequency of refetching the chat in milliseconds
 * @param enabled If set to false, the hook will not refetch the chat
 */
var useDirectChat = function (chatId, refetchInterval, enabled) {
    if (enabled === void 0) { enabled = true; }
    var _a = (0, react_1.useState)(undefined), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)("pending"), status = _b[0], setStatus = _b[1];
    // State to track the count of new messages. Incremented when a new last_message is fetched.
    var _c = (0, react_1.useState)(0), newMessageCount = _c[0], setNewMessageCount = _c[1];
    (0, react_1.useEffect)(function () {
        if (!enabled)
            return;
        var timeoutId;
        var abortController = new AbortController();
        var fetchData = function () {
            (0, data_1.fetchChat)(chatId, abortController.signal)
                .then(function (response) {
                setStatus("success");
                setData(function (prev) {
                    if (prev !== undefined &&
                        prev.last_message.id !== response.last_message.id) {
                        setNewMessageCount(function (count) { return count + 1; });
                    }
                    return response;
                });
            })
                .then(function () {
                if (refetchInterval !== undefined) {
                    timeoutId = setTimeout(function () { return fetchData(); }, refetchInterval);
                }
            })
                .catch(function (error) {
                if (error.name !== "AbortError")
                    setStatus("error");
            });
        };
        fetchData();
        return function () {
            clearTimeout(timeoutId);
            abortController.abort();
        };
    }, [enabled]);
    return { data: data, setData: setData, status: status, newMessageCount: newMessageCount };
};
exports.useDirectChat = useDirectChat;
var useUpdateChat = function () {
    var mutate = function (chatToUpdate, fieldsToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, data_1.patchChat)(chatToUpdate, fieldsToUpdate)];
        });
    }); };
    return { mutate: mutate };
};
exports.useUpdateChat = useUpdateChat;
var useChat = function (enabled) {
    // for chats
    var chatsReducer = function (state, action) {
        switch (action.type) {
            case "update": {
                return (0, helpers_1.sortChatsByLatestMessage)(state.map(function (chat) {
                    return chat.id === action.payload.id ? action.payload : chat;
                }));
            }
            case "clear": {
                return [];
            }
            case "set": {
                return (0, helpers_1.sortChatsByLatestMessage)(__spreadArray(__spreadArray([], action.payload, true), state, true)).filter(function (item, index, self) {
                    return index === self.findIndex(function (t) { return t.id === item.id; });
                });
            }
        }
        throw Error("Unknown action: " + action.type);
    };
    var FETCH_INTERVAL_CHATS = 10000;
    var INIT_PAGE_CHATS = 0;
    var _a = (0, react_1.useReducer)(chatsReducer, []), chats = _a[0], dispatchChats = _a[1];
    var _b = (0, react_1.useState)("pending"), statusChats = _b[0], setStatusChats = _b[1];
    var _c = (0, react_1.useState)(INIT_PAGE_CHATS), pageChats = _c[0], setPageChats = _c[1];
    var _d = (0, react_1.useState)("default"), filter = _d[0], setFilter = _d[1];
    var _e = (0, react_1.useState)(false), isFetchingNextPageChats = _e[0], setIsFetchingNextPageChats = _e[1];
    var _f = (0, react_1.useState)(true), hasNextPageChats = _f[0], setHasNextPageChats = _f[1];
    // for open chat
    var _g = (0, react_1.useState)(null), openChatId = _g[0], setOpenChatId = _g[1];
    var _h = (0, react_1.useState)(null), openChat = _h[0], setOpenChat = _h[1];
    var _j = (0, react_1.useState)(0), pageMessages = _j[0], setPageMessages = _j[1];
    var _k = (0, react_1.useState)(false), loadingMessages = _k[0], setLoadingMessages = _k[1];
    var _l = (0, react_1.useState)(false), isFetchingNextPageMessages = _l[0], setIsFetchingNextPageMessages = _l[1];
    var _m = (0, react_1.useState)(true), hasNextPageMessages = _m[0], setHasNextPageMessages = _m[1];
    (0, react_1.useEffect)(function () {
        dispatchChats({ type: "clear" });
        setPageChats(INIT_PAGE_CHATS);
        setStatusChats("pending");
        setOpenChat(null);
        setOpenChatId(null);
        setHasNextPageChats(true);
    }, [filter]);
    (0, react_1.useEffect)(function () {
        if (!enabled)
            return;
        var timeoutId;
        var abortController = new AbortController();
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                (0, data_1.fetchChats)(filter, INIT_PAGE_CHATS, abortController.signal)
                    .then(function (response) {
                    setStatusChats("success");
                    handleResponseFetchChats(response);
                    timeoutId = setTimeout(function () { return fetchData(); }, FETCH_INTERVAL_CHATS);
                })
                    .catch(function (error) {
                    if (error.name !== "AbortError")
                        setStatusChats("error");
                });
                return [2 /*return*/];
            });
        }); };
        fetchData();
        return function () {
            abortController.abort(); // abort current fetch request
            clearTimeout(timeoutId);
        };
    }, [filter, enabled]);
    var fetchNextPageChats = function () {
        var nextPage = pageChats + 1;
        setIsFetchingNextPageChats(true);
        (0, data_1.fetchChats)(filter, nextPage)
            .then(function (response) {
            handleResponseFetchChats(response);
            setPageChats(nextPage);
        })
            .finally(function () {
            setIsFetchingNextPageChats(false);
        });
    };
    var handleResponseFetchChats = function (response) {
        if (response.length === 0)
            setHasNextPageChats(false);
        dispatchChats({ type: "set", payload: response });
    };
    (0, react_1.useEffect)(function () {
        if (openChatId === null)
            return;
        var found = chats.find(function (chat) { return chat.id === openChatId; });
        if (found === undefined)
            return;
        if (found.last_message.id !== (openChat === null || openChat === void 0 ? void 0 : openChat.last_message.id)) {
            updateMessagesOfOpenChat();
        }
    }, [chats]);
    (0, react_1.useEffect)(function () {
        if (openChatId === null) {
            setOpenChat(null);
            return;
        }
        setLoadingMessages(true);
        setPageMessages(0);
        setHasNextPageMessages(true);
        updateMessagesOfOpenChat();
    }, [openChatId]);
    (0, react_1.useEffect)(function () {
        if (openChat)
            updateReadStatus(openChat);
    }, [openChat]);
    var updateMessagesOfOpenChat = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (initPage) {
            var newOpenChat_1;
            if (initPage === void 0) { initPage = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(openChatId !== null)) return [3 /*break*/, 2];
                        newOpenChat_1 = null;
                        return [4 /*yield*/, (0, data_1.fetchMessages)(openChatId, initPage).then(function (data) {
                                if (openChat === null || openChat.id !== openChatId) {
                                    newOpenChat_1 = chats.find(function (chat) { return chat.id === openChatId; }) || null;
                                    if (newOpenChat_1 === null)
                                        return;
                                    newOpenChat_1.messages = (0, helpers_1.sortFromLatestToOldest)(data);
                                }
                                else {
                                    // remove duplicate messages by id and remove messages with temporary ids
                                    var newMessages = (0, helpers_1.sortFromLatestToOldest)(__spreadArray(__spreadArray([], openChat.messages, true), data, true))
                                        .filter(function (item, index, self) {
                                        return index === self.findIndex(function (t) { return t.id === item.id; });
                                    })
                                        .filter(function (item) { return typeof item.id === "number"; });
                                    newOpenChat_1 = __assign(__assign({}, openChat), { messages: newMessages, last_message: newMessages[newMessages.length - 1] });
                                }
                                setOpenChat(newOpenChat_1);
                                setLoadingMessages(false);
                                setIsFetchingNextPageMessages(false);
                                if (pageMessages > 0 && data.length === 0)
                                    setHasNextPageMessages(false);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    var fetchNextPageMessages = function () {
        setIsFetchingNextPageMessages(true);
        updateMessagesOfOpenChat(pageMessages + 1).then(function () {
            setPageMessages(pageMessages + 1);
        });
    };
    var handleSwitchOpenChatId = function (e) {
        var _a;
        var target = (_a = e.currentTarget.closest("li")) === null || _a === void 0 ? void 0 : _a.dataset.chatId;
        var newOpenChatId = target === undefined ? null : parseInt(target);
        var found = chats.find(function (chat) { return chat.id == newOpenChatId; });
        found === undefined ? setOpenChatId(null) : setOpenChatId(newOpenChatId);
    };
    var updateReadStatus = function (chat) {
        var unreadMessages = chat.messages.filter(function (message) {
            return message.sender_type !== chat.user_role && message.read === null;
        });
        if (unreadMessages.length === 0)
            return;
        var newMessages = chat.messages.map(function (m) {
            return unreadMessages.includes(m) ? __assign(__assign({}, m), { read: "true" }) : m;
        });
        var newChat = __assign(__assign({}, chat), { messages: newMessages, last_message: newMessages[newMessages.length - 1] });
        dispatchChats({ type: "update", payload: newChat });
        var updatePromises = unreadMessages.map(function (message) {
            (0, data_1.patchMessage)(message, { read: null });
        });
        Promise.all(updatePromises)
            .catch(function (error) {
            console.error("Error updating read status:", error);
        })
            .finally(function () { return setOpenChat(newChat); });
    };
    /**
     * Update the properties of a chat by a making patch request and updating states.
     *
     * @param chatToUpdate - The chat object to update.
     * @param fieldToUpdate - An object containing the field to update. It can be either `tenant_blocked` or `landlord_blocked`.
     * @returns A promise that resolves to a boolean indicating whether the update was successful.
     */
    var updateChat = function (chatToUpdate, fieldsToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
        var success, newChat;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, data_1.patchChat)(chatToUpdate, fieldsToUpdate)];
                case 1:
                    success = _a.sent();
                    if (!success)
                        return [2 /*return*/, false];
                    newChat = __assign(__assign({}, chatToUpdate), fieldsToUpdate);
                    dispatchChats({ type: "update", payload: newChat });
                    setOpenChat(newChat);
                    return [2 /*return*/, true];
            }
        });
    }); };
    /**
     * Update the properties of a chat by making a patch request and updating states optimistically.
     *
     * @param chatToUpdate - The chat to update.
     * @param fieldToUpdate - An object containing the field to update. It can be either `tenant_blocked` or `landlord_blocked`.
     * @returns The updated chat object.
     */
    var updateChatOptimistically = function (chatToUpdate, fieldsToUpdate) {
        var newChat = __assign(__assign({}, chatToUpdate), fieldsToUpdate);
        (0, data_1.patchChat)(chatToUpdate, fieldsToUpdate);
        dispatchChats({ type: "update", payload: newChat });
        setOpenChat(newChat);
    };
    /**
     * Adds a message to a chat. Makes a post and patch request and updates states.
     * If the chat is hidden, it will be unhidden.
     *
     * @param chat Chat object to which the message will be added
     * @param message Message object to be added to the chat
     */
    var addMessage = function (chat, message) {
        var newChat = __assign(__assign({}, chat), { messages: __spreadArray([message], chat.messages, true), last_message: message });
        (0, data_1.postMessage)(message);
        if (chat.landlord_hide === true) {
            updateChatOptimistically(chat, { landlord_hide: false });
            newChat = __assign(__assign({}, newChat), { landlord_hide: false });
        }
        dispatchChats({ type: "update", payload: newChat });
        setOpenChat(newChat);
    };
    var updateHideStatus = function (chatToUpdate, action) {
        var fieldToUpdate = { landlord_hide: action === "hide" };
        updateChatOptimistically(chatToUpdate, fieldToUpdate);
        if ((filter === "default" && action === "hide") ||
            (filter === "landlord_hide" && action === "unhide")) {
            // closes chat window
            setOpenChatId(null);
        }
    };
    return {
        chats: chats,
        statusChats: statusChats,
        filter: filter,
        openChat: openChat,
        openChatId: openChatId,
        loadingMessages: loadingMessages,
        isFetchingNextPageMessages: isFetchingNextPageMessages,
        isFetchingNextPageChats: isFetchingNextPageChats,
        hasNextPageMessages: hasNextPageMessages,
        hasNextPageChats: hasNextPageChats,
        setFilter: setFilter,
        setOpenChatId: setOpenChatId,
        handleSwitchOpenChatId: handleSwitchOpenChatId,
        addMessage: addMessage,
        fetchNextPageChats: fetchNextPageChats,
        updateChat: updateChat,
        fetchNextPageMessages: fetchNextPageMessages,
        updateHideStatus: updateHideStatus,
    };
};
exports.useChat = useChat;
var useChatListCollapse = function (openChatId) {
    var _a = (0, react_1.useState)(false), listCollapsed = _a[0], setListCollapsed = _a[1];
    (0, react_1.useEffect)(function () {
        if (openChatId === null)
            setListCollapsed(false);
        else
            setListCollapsed(true);
    }, [openChatId]);
    return { listCollapsed: listCollapsed };
};
exports.useChatListCollapse = useChatListCollapse;
/**
 * Hook that utilizes BroadcastChannel API to disallow chat in multiple tabs
 */
var useEnablingChat = function (uniqueIdentifier) {
    var _a = (0, react_1.useState)(true), enabled = _a[0], setEnabled = _a[1];
    (0, react_1.useEffect)(function () {
        window.name = "chat-tab-".concat(Math.random());
        var channel = new BroadcastChannel("chat-".concat(uniqueIdentifier));
        channel.postMessage({ type: "new tab", tabId: window.name });
        channel.onmessage = function (event) {
            if (event.data.tabId === window.name)
                return;
            if (event.data.type === "new tab")
                setEnabled(false);
        };
        return function () {
            channel.close();
        };
    }, [setEnabled]);
    var enableOnCurrentWindow = function () {
        var channel = new BroadcastChannel("chat-".concat(uniqueIdentifier));
        channel.postMessage({ type: "new tab", tabId: window.name });
        setEnabled(true);
    };
    return { enabled: enabled, enableOnCurrentWindow: enableOnCurrentWindow };
};
exports.useEnablingChat = useEnablingChat;
/**
 * Hook to observe the intersection of a target element. Used to implement infinite scrolling.
 */
var useIntersectionObserver = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.threshold, threshold = _a === void 0 ? 1 : _a, _b = options.root, root = _b === void 0 ? null : _b, _c = options.rootMargin, rootMargin = _c === void 0 ? "0px" : _c;
    var _d = (0, react_1.useState)(null), entry = _d[0], setEntry = _d[1];
    var previousObserver = (0, react_1.useRef)(null);
    var customRef = (0, react_1.useCallback)(function (node) {
        if (previousObserver.current) {
            previousObserver.current.disconnect();
            previousObserver.current = null;
        }
        if ((node === null || node === void 0 ? void 0 : node.nodeType) === Node.ELEMENT_NODE) {
            var observer = new IntersectionObserver(function (_a) {
                var entry = _a[0];
                setEntry(entry);
            }, { threshold: threshold, root: root, rootMargin: rootMargin });
            observer.observe(node);
            previousObserver.current = observer;
        }
    }, [threshold, root, rootMargin]);
    return [customRef, entry];
};
exports.useIntersectionObserver = useIntersectionObserver;
